import * as React from 'react';
import { accentUtils } from '../../services/HelperService';
import { AccentTextUnbound } from '../unbound/AccentTextUnBound';
import { ConfiguratorContext } from './ConfigContextProvider';
import { configEventControlType, configEvents, getOptionModel, isReadOnly, onSimpleOptionValueChanged,  toGuid,  useChanged, useRefreshKey, useValidation } from './ProductConfiguratorShared';

export const ConfigText = props => {


    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);

    
    const validation = useValidation(props.optionID, "ConfigNumeric");

    const [value, setValue] = React.useState(accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : optionModel.CurrentValueAsString?.toString());

    const refreshKey = useRefreshKey(props.optionID, value);

    const fireChange = React.useMemo(() => onSimpleOptionValueChanged(), [props.optionID]);


    const onChange = React.useCallback(e => {

        fireChange(ctx, optionModel, e).then(() => {
            ctx.config?.Publish(configEvents.controlLostFocus, configEventControlType.text);
        })

        setValue(e);

    }, [setValue, ctx, optionModel, fireChange]);

    const onFocus = React.useCallback(e => {

        ctx.config?.Publish(configEvents.controlGotFocus, configEventControlType.text);

    }, [ctx]);

    const notifyDirty = React.useCallback(e => {

        if (ctx.notifyDirty) {
            ctx.notifyDirty();
        }

    }, [ctx]);


    const readOnly = isReadOnly(optionModel);


    return <div className="config-control config-text">
        <AccentTextUnbound
            key={refreshKey.refreshID}
            required={validation.required}
            defaultValue={accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : optionModel.CurrentValueAsString?.toString()}
            onBlur={onChange}
            onFocus={onFocus}
            onChange={notifyDirty}
            disabled={readOnly}            
        />
    </div>;
};

